import { ICustomerClient } from "./ICustomerClient"

import { ISelectListItem } from "@/types/ui"

export interface IDocumentFile {
  content: string
  name: string
}

export interface IDriver {
  id: number
  fullName: string
  firstName: string
  lastName: string
  isCitizenRussian: boolean
  "birthDate": string
  "birthPlace": string
  patronymic: string
  identityDocument: IIdentityDocument
  region: string
  district: string
  settlement: string
  street: string
  house: string
  building: string
  apartment: string
  phone: string
  passportScans?: IDocumentFile[]
  consentScans?: IDocumentFile[]
  adrScans?: IDocumentFile[]
  driverLicenseScans?: IDocumentFile[]
  createdByName?: string
  approved: boolean
  verificationStatus: number
	verificationStatusText: string
  clients: ICustomerClient[]
}

export interface IDriverCreate {
  fullName: string
  firstName: string
  lastName: string
  isCitizenRussian: boolean
  birthDate: string
  birthPlace: string
  patronymic: string
  passportNumber?: string
  passportSeries?: string
  passportIssuedBy?: string
  passportDivisionCode?: string
  reasonForIssue?: string
  decisionNumber?: string
  decisionDate?: string
  passportDate?: string
  validUntil?: string
  typeIdentityDocument?: number
  region: string
  district: string
  settlement: string
  street: string
  house: string
  building: string
  apartment: string
  phone: string
  passportScans?: IDocumentFile[]
  consentScans?: IDocumentFile[]
  adrScans?: IDocumentFile[]
  driverLicenseScans?: IDocumentFile[]
  approved: boolean
  clientIds: number[]
}

export interface IIdentityDocument {
  passportNumber?: string
  passportSeries?: string
  passportIssuedBy?: string
  passportDivisionCode?: string
  reasonForIssue?: string
  decisionNumber?: string
  decisionDate?: string
  passportDate?: string
  validUntil?: string
  typeIdentityDocument?: number
}

export interface IDriverSelectListItem extends ISelectListItem {
  verificationStatus: VerificationStatus
}

export enum VerificationStatus
{
    Awaits,
    Rejected,
    Confirmed,
    AwaitsForScans
}

export enum IDriverTypeIdentityDocument {
  RussianPassport,
  RussianResidencePermit,
  RussianTemporaryIdentityCard,
  BelorussianPassport
}

export const DriverTypeIdentityDocumentForSelect = [
  { id: IDriverTypeIdentityDocument.RussianPassport, value: "Паспорт гражданина РФ" },
  { id: IDriverTypeIdentityDocument.RussianResidencePermit, value: "Вид на жительство в РФ" },
  { id: IDriverTypeIdentityDocument.RussianTemporaryIdentityCard, value: "Временное удостоверение личности в РФ" },
  { id: IDriverTypeIdentityDocument.BelorussianPassport, value: "Паспорт гражданина РБ" }
]

export enum IDriverIsCitizenRussianFederation {
  Yes,
  No
}

export const DriverCitizenRussianFederationForSelect = [
  { id: IDriverIsCitizenRussianFederation.Yes, value: "является" },
  { id: IDriverIsCitizenRussianFederation.No, value: "не является" }
]

export const DriverVerificationStatusForSelect = [
  { id: VerificationStatus.Awaits, name: "ожидает" },
  { id: VerificationStatus.Rejected, name: "отклонен" },
  { id: VerificationStatus.Confirmed, name: "подтвержден" },
  { id: VerificationStatus.AwaitsForScans, name: "ожидает загрузки сканов" }
]

export interface IDriverUpdate extends IDriverCreate {
  id: number
}

export interface IDriverChangeVerificationStatus {
  id : number
  status : VerificationStatus
}

export interface IUploadDriverScansRequest {
  passportScans?: IDocumentFile[]
  consentScans?: IDocumentFile[]
  adrScans?: IDocumentFile[]
  driverLicenseScans?: IDocumentFile[]
  driverId: number
}

export const DRIVERS_KEY = "DRIVERS_KEY"